// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Helvetica',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
    ].join(','),
  },
   palette: {
    primary: {
      main: '#1F6B43',
      light: '#94C97E',
    },
    secondary: {
      main: '#BAD9AD',
    },
    error: {
      main: '#D9534F',
    },
    warning: {
      main: '#FFE9A7',
    },
    background: {
      default: '#FAFAFA',
    },
    text: {
      primary: '#212121',
      secondary: '#666666',
    },
  },
    components: {
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5', // Applique le fond à toute la table
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          backgroundColor: '#fafafa', // Applique le fond au body du tableau
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          backgroundColor: '#fafafa', // Applique à chaque cellule
        },
        head: {
          backgroundColor: '#e0e0e0', // Fond de l'en-tête
        },
      },
    },
  },
});

export default theme;